














































import Vue from 'vue'
import { mapGetters } from 'vuex'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import CAvatar from '~/components/shared/configurable/image/avatar/CAvatar.vue'
import { Geolocation } from '~/models/common/types'
import CDirectionsButton from '~/components/shared/configurable/map/CDirectionsButton.vue'

export default Vue.extend({
  components: {
    CDirectionsButton,
    CAvatar
  },
  props: {
    seller: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(CLASSIFIED_VIEW_NS, {
      sellerIsAgent: 'sellerIsAgent'
    }),
    directionUrl(): string | null {
      if (this.seller?.geolocation?.length) {
        const [lat, lng] = this.seller.geolocation
        return `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`
      }
      return null
    },
    sellerGeolocation(): Geolocation | undefined {
      const { geolocation } = this.seller
      return geolocation && { lat: geolocation[0], lon: geolocation[1] }
    },
    directionsLink() {
      return (
        this.sellerGeolocation &&
        `https://www.google.com/maps/dir/?api=1&destination=${this.sellerGeolocation.lat},${this.sellerGeolocation.lon}`
      )
    }
  }
})
